// extracted by mini-css-extract-plugin
export var icon = "_ao-3";
export var subtitle = "_ao-2";
export var title = "_ao-1";
export var value = "_ao-0";